/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_User_Credentials_ResetInputs */



/**
* | output |
* | --- |
* | "Credentials Reset" |
*
* @param {Audit_Details_User_Credentials_ResetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_user_credentials_reset = /** @type {((inputs?: Audit_Details_User_Credentials_ResetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_User_Credentials_ResetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugangsdaten zurückgesetzt")
	return /** @type {LocalizedString} */ ("Credentials Reset")
});